export default __webpack_public_path__ + "static/media/Pauldrons of Indra.fb31e765.jpg";